import {useMediaQueries} from 'presentation/pages/private/hooks';
import React, {Fragment} from 'react';
import {AlertModal} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import {Button} from '@mui/material';
import {useQueryClient} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {useLifeplaceLinkQuery} from '../../../queries/useLifeplaceLinkQuery';
import {MobileBanner} from './MobileBanner';
import {DesktopBanner} from './DesktopBanner';

const {serverError, serverErrorTitle, tryAgain, notice} = translations['pt-br'].commons;

export const LifeplaceBanner = () => {
	const {isMobile} = useMediaQueries();
	const queryClient = useQueryClient();
	const {data: lifeplaceLink, refetch, isFetching, isError} = useLifeplaceLinkQuery();

	const handleClick = async () => {
		if (lifeplaceLink) {
			window.open(lifeplaceLink, '_blank');
		} else {
			const {data: link} = await refetch();
			if (link) {
				window.open(link, '_blank');
			}
		}
	};

	const handleCloseErrorModal = () => {
		queryClient.resetQueries({queryKey: [QUERY_KEYS.LIFEPLACE_LINK]});
	};

	return (
		<Fragment>
			{isMobile ? (
				<MobileBanner isFetching={isFetching} handleClick={handleClick} />
			) : (
				<DesktopBanner isFetching={isFetching} handleClick={handleClick} />
			)}

			{isError ? (
				<AlertModal
					open={isError}
					onClose={handleCloseErrorModal}
					description={serverError}
					title={serverErrorTitle}
					headerTitle={notice}
					variant="info"
					footerContent={
						<Button
							variant="contained"
							size="large"
							fullWidth
							onClick={() => refetch()}>
							{tryAgain}
						</Button>
					}
				/>
			) : null}
		</Fragment>
	);
};
